import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
// First, create the thunk
export const fetchPizzas = createAsyncThunk('pizza/fetchPizzasStatus', async (params) => {
  const { orderBy, sortBy, category, search, currentPage } = params;
  const { data } = await axios.get(
    `https://62dbc5434438813a260a01f3.mockapi.io/items?page=${currentPage}&${category}&sortBy=${sortBy}&order=${orderBy}${search}`,
  );
  return data;
});

const initialState = {
  items: [],
  status: 'loading', //loading | success | error
};

const pizzaSlice = createSlice({
  name: 'pizza',
  initialState,
  reducers: {
    setItems(state, action) {
      state.items = action.payload;
    },
  },
  extraReducers: {
    [fetchPizzas.pending]: (state) => {
      state.status = 'loading';
      state.items = [];
    },
    [fetchPizzas.fulfilled]: (state, action) => {
      state.items = action.payload;
      state.status = 'success';
    },
    [fetchPizzas.rejected]: (state) => {
      state.status = 'error';
      state.items = [];
    },
  },
});
export const filterSelector = (state) => state.filter;
export const selectPizzaData = (state) => state.pizza;
export const { setItems } = pizzaSlice.actions;
export default pizzaSlice.reducer;
